var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthGoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,12c0.3-0.6,0.7-2.3,0.7-3.5C28,3.8,24.7,0,20.6,0c-2.8,0-5.3,1.8-6.6,4.5C12.7,1.8,10.3,0,7.4,0 C3.3,0,0,3.8,0,8.5c0,1.7,0.4,3.2,1.1,4.5l1.5,2c0,0,9.5,11.6,10.1,12.4c0.7,0.8,1.8,0.8,2.5,0C15.9,26.6,25.4,15,25.4,15 C26,14.2,27,12.6,27.3,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthGoodIcon);
export default __webpack_public_path__ + "static/media/health-good-icon.142f6b801cb191264e9fcbc0f39ce635.svg";
export { ForwardRef as ReactComponent };